//TODO - добавить обработку хедеров, авторизацию по токену

import axios from "axios"
import { useToast } from "vue-toastification"

const apiUrl = process.env.VUE_APP_API_URL
const debug = process.env.NODE_ENV !== 'production'
const toast = useToast();

const ignoreResponseCodes = [403, 401];

export default {

async getFrApi (reqObj, notToast = false) {
    return new Promise((resolve, reject) => {
        if (typeof reqObj.params === "undefined") { reqObj.params = {}; }
        reqObj.params["app_name"] = process.env.VUE_APP_NAME
        if (typeof reqObj.locale !== "undefined") { reqObj.params["lang"] = reqObj.locale; }
        
        let params = {}
        const methods_list = ['get', 'post', 'put', 'patch', 'delete']
        const params_methods_list = ['post', 'put', 'patch']
        let apiMethod = (reqObj.method) ? reqObj.method.trim().toLowerCase() : 'get'
        if (!apiMethod || !methods_list.contains(apiMethod)) apiMethod = 'get'

        if (!notToast && !reqObj.url) {
            toast.error('Incorrect API URL!');
            reject('Incorrect API URL!')
        } 
        if (params_methods_list.contains(apiMethod) && reqObj.params && typeof reqObj.params === 'object') {
            params = reqObj.params
        }
        if (reqObj.token){
            // Авторизация по токену
            const error = 'No token access yet!'
            if (debug) console.log(error)
            toast.error(error);
            reject(error)
        } else {
            // Авторизация через сессию
            if (params_methods_list.contains(apiMethod)) {
                // Передача с параметрами
                axios[apiMethod](apiUrl + reqObj.url, params, reqObj.options).then(response => {
                    const responseCode = response.data.code ?? response.status;
                    if (response.data.success){
                        if (debug) console.log(response)
                        resolve(response)
                    } else {
                        if(!notToast && ignoreResponseCodes.indexOf(responseCode) === -1) toast.error(response.data.message);
                        this.error = response.data.message
                        if (debug) console.log('No API success: ' + (response.data.message || ""))
                        reject(response)
                    }
                }).catch((error) => {
                    const responseCode = error.status ?? 500;
                    if(!notToast && ignoreResponseCodes.indexOf(responseCode) === -1)
                        toast.error(error.response ? error.response.data.message : error.message);
                    if (error.response) {
                        if (debug) console.log(error.response)
                        reject(error.response)
                    } else {
                        const resp = {data: {success: false, message: error}}
                        if (debug) console.log(resp)
                        reject(resp)
                    }
                })
            } else {
                // Передача без параметров
                axios[apiMethod](apiUrl + reqObj.url, {params: reqObj.params}).then(response => {
                    const responseCode = response.data.code ?? response.status;
                    if (response.data.success){
                        if (debug) console.log(response)
                        resolve(response)
                    } else {
                        if(!notToast && ignoreResponseCodes.indexOf(responseCode) === -1) toast.error(response.data.message);
                        this.error = response.data.message
                        if (debug) console.log('No API success: ' + (response.data.message || ""))
                        reject(response)
                    }
                }).catch((error) => {
                    const responseCode = error.status ?? 500;
                    if(!notToast && ignoreResponseCodes.indexOf(responseCode) === -1)
                        toast.error(error.response ? error.response.data.message : error.message);
                    if (error.response) {
                        if (debug) console.log(error.response)
                        reject(error.response)
                    } else {
                        const resp = {data: {success: false, message: error}}
                        if (debug) console.log(resp)
                        reject(resp)
                    }
                })
            }
        }
    })
}


}
